"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingUpdatesTableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var UnderwritingUpdatesTableRow = /** @class */ (function (_super) {
    __extends(UnderwritingUpdatesTableRow, _super);
    function UnderwritingUpdatesTableRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnderwritingUpdatesTableRow.prototype.render = function () {
        var claim = this.props.claim;
        return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { className: "d-block text-primary", to: "/customers/".concat(this.props.params.id, "/underwritingUpdate/").concat(claim.claimNumber), state: {
                            claim: claim,
                            policies: this.props.location.state.policies,
                            customerName: this.props.location.state.customerName
                        }, children: claim.claimNumber }) }), (0, jsx_runtime_1.jsx)("td", { children: claim.policy.policyNumber }), (0, jsx_runtime_1.jsx)("td", { children: claim.lossCause.code }), (0, jsx_runtime_1.jsx)("td", { children: SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(Date.parse(claim.lossDate)) }), (0, jsx_runtime_1.jsx)("td", { children: "ClaimsCenter" })] }));
    };
    UnderwritingUpdatesTableRow = __decorate([
        components_1.authorize
    ], UnderwritingUpdatesTableRow);
    return UnderwritingUpdatesTableRow;
}(React.Component));
exports.UnderwritingUpdatesTableRow = UnderwritingUpdatesTableRow;
exports.default = (0, components_1.withRouter)(UnderwritingUpdatesTableRow);
//# sourceMappingURL=UnderwritingUpdatesTableRow.js.map